module.exports = __webpack_public_path__ + "img/mumei.b5136f12.png";